import React, { Fragment } from "react";
import BoxShadow from "../../../../Common/Components/BoxShadow";

function VerticalCard({
  value,
  icon,
  title,
  src,
  amount,
  className = false,
  access = {
    method: () => { },
    style: {},
  },
}) {
  return (
    <div
      className={
        className || "col-xl-3 col-md-4  col-sm-6 mb-3 rounded-5 col-12 "
      }
      style={{ ...access.style }}
      onClick={access.method}
    >
      <BoxShadow className="VCBoxContent">
        <div className="row mx-0 justify-content-center VCBox">
          <div className="VcImgBox">
            <img src={src} width="50px" height={"50px"} />
          </div>
          <div style={{ flex: 1 }}>
            <h6
              className="card-title-dashboard text-center"
              style={{
                color: "#000",
              }}
            >
              {title}
            </h6>
            <div className="value-card-title-dashboard">
              <h5 className=" text-center" style={{ color: "#000" }}>
                {value + " "}
                {amount && amount}
              </h5>
            </div>
          </div>
        </div>

        {/* <div className="title d-flex">
          <div className="icon">
            <i class={icon}></i>
          </div>
          <div className="text text-white mr-2">
            <h4 className="m-0" style={{ alignSelf: "center" }}>
              {title}
            </h4>
          </div>
        </div>
        <div className="value" style={{ marginTop: "auto" }}>
          <h3 className="text-right text-white">{value}</h3>
        </div> */}
      </BoxShadow>
    </div>
  );
}

export default VerticalCard;
